import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AuthGuard } from 'src/guards/auth.guard';
import { ProjectDashboardComponent } from './project-dashboard/project-dashboard.component';
import { WrapperComponent } from 'src/app/wrapper/wrapper.component';

const routes: Routes = [
    {
        path: '',
        component: ProjectDashboardComponent,
    },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ProjectDashboardRoutingModule { }
